import * as React from 'react';
import * as _ from 'lodash';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, AppActionCreators, MatchActionCreators, IEvaluateRecipientDonorResponse, DonorActionCreators, RecipientActionCreators, CenterActionCreators, DonorPreselectActionCreators, FileActionCreators, IAppState, IAmbraDirectToViewerResponse } from '@nkr/store/index';
import { IRecipient, IDonor, ICompatibilityResult, ILkdpiResults, IDonorPreselectNote, ISerologyTest, IBaseResponse, ICenterAddress, IState as IStateItem, IContact, ISingleEpletMmRisk } from '@nkr/models/index';
import { CenterAddressType, CenterContactPosition, FileDocumentType, FileDocumentTypeDescription } from '@nkr/enums/index';
import { ControlLabel, FormControl } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { downloadFile } from '@nkr/services/download-file';
import Match from './match';
import SerologyTests from './modals/serology-tests';
import TopButtons from './top-buttons';
import CenterAddress from './modals/center-address';
import CenterAddresses from './center-addresses';
import RecipientNav from '../recipients/recipient-nav';

interface IProps {
    recipientId: number,
    donorId: number,
    centerId: number,
    onUpdateRecipientAlias: (alias: string) => void,
    onDownloadFormsAndChecklist: (donorId: number, recipientId: number) => void
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getRecipientDonor: (recipientId: number, donorId: number, centerId: number) => Promise<IEvaluateRecipientDonorResponse>,
    updateDonorSurgeon: (donorId: number, contactId: number) => Promise<IBaseResponse>,
    updateRecipientSurgeon: (recipientId: number, contactId: number) => Promise<IBaseResponse>,
    updateCenterAddress: (id: number, centerId: number, typeId: number, addressLine1: string, addressLine2: string, addressLine3: string, city: string, state: number, postalCode: string, note: string, label: string, firstName: string, lastName: string) => Promise<IBaseResponse>,
    saveNotes: (recipientCenterId: number, donorId: number, recipientId: number, note: string) => Promise<IBaseResponse>,
    getFinancialAgreement: (centerId: number, donorId: number, recipientId: number) => Promise<any>,
    downloadFile: (docType: number, lookupId: number) => Promise<any>,
    getAmbraLink: (donorId: number) => Promise<IAmbraDirectToViewerResponse>,
}

type TProps =
    IProps
    & IStateProps
    & IDispatchProps;

interface IState {
    recipient: IRecipient,
    donor: IDonor,
    compatibilityResult: ICompatibilityResult,
    lkdpiResults: ILkdpiResults,
    compatiblePairLkdpiResults: ILkdpiResults,
    singleEpletMmRisk: ISingleEpletMmRisk,
    isRecipientCenter: boolean,
    recipientCenterContacts: IContact[],
    isDonorCenter: boolean,
    donorCenterContacts: IContact[],
    donorNote: IDonorPreselectNote,
    donorNotesContent: string,
    matchNote: IDonorPreselectNote,
    matchNotesContent: string,
    donorKidneyPickupAddress: ICenterAddress,
    donorKidneyShipToAddress: ICenterAddress,
    recipientKidneyPickupAddress: ICenterAddress,
    recipientKidneyShipToAddress: ICenterAddress,
    swapNumber: string,
    serologyTestList: ISerologyTest[],
    lookupData: {
        stateList: IStateItem[]
    },
    doesStudyExist: number,
    centerAddress: {
        show: boolean,
        data: ICenterAddress
    },
    showSerologyTests: boolean
}

class EvaluateRecipientDonor extends React.Component<TProps, IState> {
    readonly state: IState = {
        recipient: null,
        donor: null,
        compatibilityResult: null,
        lkdpiResults: null,
        compatiblePairLkdpiResults: null,
        singleEpletMmRisk: null,
        isRecipientCenter: false,
        recipientCenterContacts: [],
        isDonorCenter: false,
        donorCenterContacts: [],
        donorNote: null,
        donorNotesContent: '',
        matchNote: null,
        matchNotesContent: '',
        donorKidneyPickupAddress: null,
        donorKidneyShipToAddress: null,
        recipientKidneyPickupAddress: null,
        recipientKidneyShipToAddress: null,
        swapNumber: '',
        serologyTestList: [],
        lookupData: {
            stateList: []
        },
        doesStudyExist: 0,
        centerAddress: {
            show: false,
            data: null
        },
        showSerologyTests: false
    }

    useTimer: boolean = true;

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting donor & recipient information, one moment please...').then(() => {
            this.props.getRecipientDonor(this.props.recipientId, this.props.donorId, this.props.centerId).then(response => {
                if (response.data.success) {
                    let {
                        recipient, donor,
                        compatibilityResult, lkdpiResults, compatiblePairLkdpiResults, singleEpletMmRisk,
                        isRecipientCenter, recipientCenterContacts,
                        isDonorCenter, donorCenterContacts,
                        donorNote, matchNote,
                        donorKidneyPickupAddress, donorKidneyShipToAddress,
                        recipientKidneyPickupAddress, recipientKidneyShipToAddress,
                        serologyTestList,
                        doesStudyExist,
                        swapNumber,
                        lookupData
                    } = response.data.results;

                    this.setState({
                        recipient,
                        donor,
                        compatibilityResult,
                        lkdpiResults,
                        compatiblePairLkdpiResults,
                        singleEpletMmRisk,
                        isRecipientCenter,
                        recipientCenterContacts,
                        isDonorCenter,
                        donorCenterContacts,
                        donorNote,
                        donorNotesContent: donorNote != null ? donorNote.note : '',
                        matchNote,
                        matchNotesContent: matchNote != null ? matchNote.note : '',
                        donorKidneyPickupAddress, donorKidneyShipToAddress,
                        recipientKidneyPickupAddress, recipientKidneyShipToAddress,
                        serologyTestList,
                        doesStudyExist,
                        swapNumber,
                        lookupData
                    }, () => {
                        this.props.hideLoading();

                        this.props.onUpdateRecipientAlias(this.state.recipient.alias);
                    });
                }
            });
        });
    }

    getOtherCenterId = () => {
        if (!this.state.isRecipientCenter && this.state.donor.position != 1)
            return this.state.recipient.centerId;

        if (this.state.isRecipientCenter && this.state.recipient.isInChip == false)
            return this.state.donor.centerId;

        return 0;
    }

    getWaitMessage = () => {
        return 'One moment, please';
    }

    handleShowHideSerologyTests = () => {
        this.setState({
            showSerologyTests: !this.state.showSerologyTests
        });
    }

    handleUpdateRecipientSurgeon = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let contactId = parseInt(e.currentTarget.value);

        this.props.showLoading('Updating recipient surgeon, one moment please...').then(() => {
            this.props.updateRecipientSurgeon(this.state.recipient.id, contactId).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    let recipient = _.cloneDeep(this.state.recipient)
                    let compatibilityResult = _.cloneDeep(this.state.compatibilityResult);

                    recipient.surgeonContactId = contactId;
                    compatibilityResult.recipient.surgeonContactId = contactId;

                    this.setState({
                        recipient,
                        compatibilityResult
                    }, () => {
                        toast.success('Recipient surgeon updated successfully');
                    });
                } else {
                    toast.error('Unable to update the recipient surgeon');
                }
            });
        });
    }

    handleUpdateDonorSurgeon = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let contactId = parseInt(e.currentTarget.value);

        this.props.showLoading('Updating donor surgeon, one moment please...').then(() => {
            this.props.updateDonorSurgeon(this.state.donor.id, contactId).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    let donor = _.cloneDeep(this.state.donor);
                    let compatibilityResult = _.cloneDeep(this.state.compatibilityResult);

                    donor.surgeonContactId = contactId;
                    compatibilityResult.donor.surgeonContactId = contactId;

                    this.setState({
                        donor,
                        compatibilityResult
                    }, () => {
                        toast.success('Donor surgeon updated successfully');
                    });
                } else {
                    toast.error('Unable to update the donor surgeon');
                }
            });
        });
    }

    handleEditCenterAddress = (address: ICenterAddress) => {
        this.useTimer = false;

        this.setState({
            centerAddress: {
                show: true,
                data: address
            }
        });
    }

    handleSaveCenterAddress = (addressLine1: string, addressLine2: string, addressLine3: string, city: string, state: number, postalCode: string, note: string, label: string) => {
        let { id, typeId } = this.state.centerAddress.data;

        this.setState({
            centerAddress: {
                show: false,
                data: null
            }
        }, () => {
            let message = typeId == CenterAddressType.KidneyPickup ? 'Updating center pickup address, one moment please...' : 'Updateing center delivery address, one moment please...';

            this.props.showLoading(message).then(() => {
                this.props.updateCenterAddress(id, this.props.centerId, typeId, addressLine1, addressLine2, addressLine3, city, state, postalCode, note, label, '', '').then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        let stateItem = this.state.lookupData.stateList.find(x => x.id == state);

                        let donorKidneyPickupAddress = { ...this.state.donorKidneyPickupAddress };
                        let donorKidneyShipToAddress = { ...this.state.donorKidneyShipToAddress };

                        let recipientKidneyPickupAddress = { ...this.state.recipientKidneyPickupAddress };
                        let recipientKidneyShipToAddress = { ...this.state.recipientKidneyShipToAddress };

                        if (this.state.isDonorCenter) {
                            if (typeId == CenterAddressType.KidneyPickup) {
                                donorKidneyPickupAddress.addressLine1 = addressLine1;
                                donorKidneyPickupAddress.addressLine2 = addressLine2;
                                donorKidneyPickupAddress.addressLine3 = addressLine3;
                                donorKidneyPickupAddress.city = city;
                                donorKidneyPickupAddress.state = stateItem.description;
                                donorKidneyPickupAddress.stateAbbreviation = stateItem.abbreviation;
                                donorKidneyPickupAddress.postalCode = postalCode;
                            } else {
                                donorKidneyShipToAddress.addressLine1 = addressLine1;
                                donorKidneyShipToAddress.addressLine2 = addressLine2;
                                donorKidneyShipToAddress.addressLine3 = addressLine3;
                                donorKidneyShipToAddress.city = city;
                                donorKidneyShipToAddress.state = stateItem.description;
                                donorKidneyShipToAddress.stateAbbreviation = stateItem.abbreviation;
                                donorKidneyShipToAddress.postalCode = postalCode;
                            }
                        } else {
                            if (typeId == CenterAddressType.KidneyPickup) {
                                recipientKidneyPickupAddress.addressLine1 = addressLine1;
                                recipientKidneyPickupAddress.addressLine2 = addressLine2;
                                recipientKidneyPickupAddress.addressLine3 = addressLine3;
                                recipientKidneyPickupAddress.city = city;
                                recipientKidneyPickupAddress.state = stateItem.description;
                                recipientKidneyPickupAddress.stateAbbreviation = stateItem.abbreviation;
                                recipientKidneyPickupAddress.postalCode = postalCode;
                            } else {
                                recipientKidneyShipToAddress.addressLine1 = addressLine1;
                                recipientKidneyShipToAddress.addressLine2 = addressLine2;
                                recipientKidneyShipToAddress.addressLine3 = addressLine3;
                                recipientKidneyShipToAddress.city = city;
                                recipientKidneyShipToAddress.state = stateItem.description;
                                recipientKidneyShipToAddress.stateAbbreviation = stateItem.abbreviation;
                                recipientKidneyShipToAddress.postalCode = postalCode;
                            }
                        }

                        this.setState({
                            donorKidneyPickupAddress,
                            donorKidneyShipToAddress,
                            recipientKidneyPickupAddress,
                            recipientKidneyShipToAddress
                        }, () => {
                            toast.success(typeId == CenterAddressType.KidneyPickup ? 'Center pickup address updated successfully' : 'Center delivery address updated successfully');
                        });
                    } else {
                        toast.error(typeId == CenterAddressType.KidneyPickup ? 'Unable to update the center pickup address' : 'Unable to update the center delivery address');
                    }
                });
            });
        });
    }

    handleCancelCenterAddress = () => {
        this.useTimer = true;

        this.setState({
            centerAddress: {
                show: false,
                data: null
            }
        });
    }

    handleDonorNotesChange = (donorNotesContent: string) => {
        this.setState({
            donorNotesContent
        });
    }

    handleMatchNotesChange = (matchNotesContent: string) => {
        this.setState({
            matchNotesContent
        });
    }

    handleSaveNotes = (isMatch: boolean) => {
        let recipientCenterId = this.state.recipient.centerId;
        let donorId = this.state.donor.id;
        let recipientId = isMatch ? this.state.recipient.id : null;
        let notes = isMatch ? this.state.matchNotesContent : this.state.donorNotesContent;
        let loadingDescription = isMatch ? 'Saving match notes, one moment please...' : 'Saving donor notes, one moment please';
        let messagePrefix = isMatch ? 'Match notes ' : 'Donor notes ';

        this.props.showLoading(loadingDescription).then(() => {
            this.props.saveNotes(recipientCenterId, donorId, recipientId, notes)
                .then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success(messagePrefix + ' saved successfully');
                    }
                })
                .catch(error => {
                    toast.error('Unable to save ' + messagePrefix.toLowerCase());
                });
        });
    }

    handleGetFinancialInfo = () => {
        let { centerId, donorId, recipientId } = this.props;

        this.props.showLoading('Getting financial info, one moment please...').then(() => {
            this.props.getFinancialAgreement(centerId, donorId, recipientId).then((response: any) => {
                this.props.hideLoading();

                downloadFile(response.data, `financial-info-${centerId}-${donorId}-${recipientId}.pdf`, 'application/pdf');
            });
        });
    }

    handleGetFile = (docType: FileDocumentType, donorId: number) => {
        this.props.downloadFile(docType, donorId).then((response: any) => {
            downloadFile(response.data, `${FileDocumentTypeDescription[docType]}.pdf`, response.headers.contentType)
        }).catch((error: IBaseResponse) => {
            toast.error("Unable to download file at this time.  Please contact support.");
        })
    }

    handleViewCtScan = (donorId: number) => {
        this.props.getAmbraLink(donorId).then(response => {
            window.open(response.data.results, "_blank");
        });
    }

    render = () => {
        if (this.state.recipient == null || this.state.donor == null)
            return <div style={{ padding: '0px 5px' }}>{this.getWaitMessage()}...</div>;

        const includeButtons = false;

        const { donor, recipient } = this.state.compatibilityResult;

        const centerIdToPrint = this.state.isRecipientCenter ? recipient.centerId : donor.centerId;
        const centerIdForContacts = this.state.isRecipientCenter ? this.state.donor.centerId : this.state.recipient.centerId;
        const otherCenterId = this.getOtherCenterId();
        const reportDonorId = this.state.donor.id;
        const reportRecipientId = this.state.recipient.id;
        const recipientSurgeons = _.sortBy(this.state.recipientCenterContacts.filter(x => x.positions.filter(p => p.id == CenterContactPosition.KidneyRecipientSurgeon).length > 0), x => x.fullName);
        const donorSurgeons = _.sortBy(this.state.donorCenterContacts.filter(x => x.positions.filter(p => p.id == CenterContactPosition.KidneyDonorSurgeon).length > 0), x => x.fullName);
        const donorCenter = donor.rdnCenterId > 0 ? <>{donor.rdnCenterAlias}</> : <>{donor.center.alias}</>;

        console.log(recipientSurgeons);

        return (
            <div className='evaluate-recipient-donor-wrapper' style={{ padding: '0px 5px' }}>
                <RecipientNav
                    activeKey='EVALUATE-RECIPIENT-DONOR'
                    isAdmin={false}
                    isNkrLogin={false}
                    centerId={this.props.centerId}
                    recipientAlias={this.state.recipient.alias}
                    recipientId={this.props.recipientId}
                    donorId={this.props.donorId}
                />

                <div className='content-wrapper' style={{ width: "100%", minHeight: "65vh", paddingTop: 20, paddingLeft: 5, paddingRight: 5, marginBottom: 5, backgroundColor: "#FFF" }}>
                    <div className='container'>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 5, marginBottom: 20 }}>
                            <div>
                                <h2 style={{ margin: 0 }}>Evaluate Donor {donor.alias} at {donorCenter} {this.state.swapNumber != '' ? <span style={{ color: 'red' }}>(Swap {this.state.swapNumber})</span> : null}</h2>
                            </div>
                            <div className='text-right no-print'>
                                <a href={`/center/${this.props.centerId}/action-center/pending-swaps`} className='btn btn-link'>Return to Swaps Page</a>
                            </div>
                        </div>
                    </div>

                    <TopButtons
                        isRecipientCenter={this.state.isRecipientCenter}
                        donorId={donor.id}
                        recipientId={recipient.id}
                        centerIdToPrint={centerIdToPrint}
                        otherCenterId={otherCenterId}
                        centerIdForContacts={centerIdForContacts}
                        reportDonorId={reportDonorId}
                        reportRecipientId={reportRecipientId}
                        centerId={this.props.centerId}
                        donor={this.state.donor}
                        onShowHideSerologyTests={this.handleShowHideSerologyTests}
                        onDownloadFormsAndChecklists={this.props.onDownloadFormsAndChecklist}
                    />

                    <div className='container' style={{ marginBottom: 20 }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ float: 'left', width: '40%' }}>
                                {this.state.isRecipientCenter && (
                                    <div style={{ marginBottom: this.state.isRecipientCenter && this.state.isDonorCenter ? 10 : 0 }}>
                                        <ControlLabel htmlFor='RecipientSurgeon'>Recipient Surgeon</ControlLabel>
                                        <FormControl
                                            componentClass='select'
                                            value={recipient.surgeonContactId}
                                            onChange={this.handleUpdateRecipientSurgeon}
                                            style={{ width: '90%' }}
                                        >
                                            <option value=''>Please Select</option>
                                            {recipientSurgeons.map((contact, index) =>
                                                <option value={contact.id}>{contact.fullName}</option>
                                            )}
                                        </FormControl>
                                    </div>
                                )}

                                {this.state.isDonorCenter && (
                                    <div>
                                        <ControlLabel htmlFor='DonorSurgeon'>Donor Surgeon</ControlLabel>
                                        <FormControl
                                            componentClass='select'
                                            value={donor.surgeonContactId}
                                            onChange={this.handleUpdateDonorSurgeon}
                                            style={{ width: '90%' }}
                                        >
                                            <option value=''>Please Select</option>
                                            {donorSurgeons.map((contact, index) =>
                                                <option value={contact.id}>{contact.fullName}</option>
                                            )}
                                        </FormControl>
                                    </div>
                                )}
                            </div>

                            <CenterAddresses
                                isDonorCenter={this.state.isDonorCenter}
                                rdnCenterId={this.state.donor.rdnCenterId}
                                pickupCenterAlias={this.state.donor.rdnCenterId > 0 ? this.state.donor.rdnCenterAlias : this.state.donor.center.alias}
                                pickupAddress={this.state.donorKidneyPickupAddress}
                                shipToCenterAlias={this.state.recipient.center.alias}
                                shipToAddress={this.state.recipientKidneyShipToAddress}
                                kidneyPickupDateTime={this.state.donor.logistics.kidneyPickupDateTime}
                                kidneyArrivalDateTime={this.state.donor.logistics.kidneyArrivalDateTime}
                                onEditCenterAddress={this.handleEditCenterAddress}
                            />
                        </div>
                    </div>

                    <Match
                        donor={this.state.donor}
                        recipient={this.state.recipient}
                        compatibilityResult={this.state.compatibilityResult}
                        lkdpiResults={this.state.lkdpiResults}
                        compatiblePairLkdpiResults={this.state.compatiblePairLkdpiResults}
                        singleEpletMmRisk={this.state.singleEpletMmRisk}
                        donorNote={this.state.donorNote}
                        donorNotesContent={this.state.donorNotesContent}
                        matchNote={this.state.matchNote}
                        matchNotesContent={this.state.matchNotesContent}
                        includeButtons={includeButtons}
                        doesStudyExist={this.state.doesStudyExist}
                        hasOutstandingOffer={false}
                        isRecipientCenter={this.state.isRecipientCenter}
                        showNotes={true}
                        isNkrLogin={this.props.app.user.group.isSuper}
                        swapNumber={''}
                        matchHistoryId={0}
                        onDonorNotesChange={this.handleDonorNotesChange}
                        onMatchNodesChange={this.handleMatchNotesChange}
                        onSaveNotes={this.handleSaveNotes}
                        onGetFile={this.handleGetFile}
                        onViewCtScan={this.handleViewCtScan}
                    />

                    <div className='container no-print'>
                        <div className='text-center'>
                            <a href={`/center/${this.props.centerId}/action-center/pending-swaps`} className='btn btn-link'>Return to Swaps Page</a>
                        </div>
                    </div>
                </div>

                <SerologyTests
                    show={this.state.showSerologyTests}
                    serologTestList={this.state.serologyTestList}
                    centerRequiresQfg={this.state.isDonorCenter ? donor.center.requiresQfg == 1 : recipient.center.requiresQfg == 1}
                    onClose={() => this.handleShowHideSerologyTests()}
                />

                <CenterAddress
                    show={this.state.centerAddress.show}
                    centerAddress={this.state.centerAddress.data}
                    stateList={this.state.lookupData.stateList}
                    onSave={this.handleSaveCenterAddress}
                    onCancel={this.handleCancelCenterAddress}
                />
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getRecipientDonor: (recipientId, donorId, centerId) => {
            return dispatch(MatchActionCreators.getRecipientDonor(recipientId, donorId, centerId));
        },
        updateDonorSurgeon: (donorId, contactId) => {
            return dispatch(DonorActionCreators.updateSurgeon(donorId, contactId));
        },
        updateRecipientSurgeon: (recipientId, contactId) => {
            return dispatch(RecipientActionCreators.updateSurgeon(recipientId, contactId));
        },
        updateCenterAddress: (id, centerId, typeId, addressLine1, addressLine2, addressLine3, city, stateId, postalCode, note, label) => {
            return dispatch(CenterActionCreators.updateCenterAddress({ id, centerId, typeId, addressLine1, addressLine2, addressLine3, city, stateId, postalCode, note, label, firstName: '', lastName: '', shipToPhoneNumber: '' }));
        },
        saveNotes: (recipientCenterId, donorId, recipientId, note) => {
            return dispatch(DonorPreselectActionCreators.saveNotes(recipientCenterId, donorId, recipientId, note));
        },
        getFinancialAgreement: (centerId, donorId, recipientId) => {
            return dispatch(FileActionCreators.getFinancialAgreement(centerId, donorId, recipientId));
        },
        downloadFile: (docType, id) => {
            return dispatch(FileActionCreators.downloadFile(docType, id))
        },
        getAmbraLink: (donorId) => {
            return dispatch(DonorActionCreators.getAmbraLink(donorId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(EvaluateRecipientDonor)